import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>جميع الحقوق محفوظة © {new Date().getFullYear()} - تعلم الإنجليزية للأطفال</p>
        <ul className="social-links">
          <li><a href="#" aria-label="Facebook">Facebook</a></li>
          <li><a href="#" aria-label="Instagram">Instagram</a></li>
          <li><a href="#" aria-label="Twitter">Twitter</a></li>
        </ul>
        <p>تواصل معنا: nagamwagdy4@gmail.com | 01103303645</p>
      </div>
    </footer>
  );
};

export default Footer;
